import {useEffect, useState} from "react";
import styles from "../../User/User.module.css";
import {useLocation, useNavigate} from "react-router-dom";
import {Const} from "../../../component/const/Const";

export const FilterSection = ({checkboxData, setSearchQuery, search, data}) => {
    const nav = useNavigate();
    const {pathname} = useLocation();

    const [hiddenFilter, setHiddenFilter] = useState(new Set());

    // 값 추가 예시
    const addFilter = (value) => {
        setHiddenFilter(prev => new Set(prev).add(value));
    };

    // 값 제거 예시
    const removeFilter = (value) => {
        const newSet = new Set(hiddenFilter);
        newSet.delete(value);
        setHiddenFilter(newSet);
    };
    const getInitialSelected = (data) => {
        const result = {};
        for (const [key, values] of Object.entries(data)) {
            result[key] = []; // 모든 체크박스 선택 안함
        }
        return result;
    };

    const [selected, setSelected] = useState(getInitialSelected(checkboxData));
    const handleChange = (group, value) => {
        setSelected((prev) => {
            const groupValues = new Set(prev[group] || []);

            if (groupValues.has(value)) {
                groupValues.delete(value);
            } else {
                groupValues.add(value);
            }

            return {
                ...prev,
                [group]: Array.from(groupValues),
            };
        });

    };
    useEffect(() => {
        // console.log(selected)
        setSearchQuery(generatePostgrestURL())
        // console.log(decodeURIComponent(generatePostgrestURL()))
    }, [selected]);

    const download = () => {
        // CSV 헤더 생성
        let csvHeader = Object.keys(data[0]).join(',') + '\n';

        // CSV 내용 생성
        let csvContent = data.map(item => Object.values(item).join(',')).join('\n');

        // 전체 CSV 문자열
        let csvString = csvHeader + csvContent;

        // Blob 객체 생성
        let blob = new Blob([csvString], {type: 'text/csv'});

        // URL 생성
        let url = URL.createObjectURL(blob);

        // a 태그 생성
        let a = document.createElement('a');
        a.href = url;
        a.download = 'data.csv';

        // 클릭 이벤트 시킴
        a.click();

        // 메모리에서 URL을 제거
        URL.revokeObjectURL(url);
    }

    const encodeParam = (key, values) => {
        // 숫자 여부를 체크하는 헬퍼
        const isNumeric = (v) => !isNaN(Number(v));

        // 모든 값이 숫자인 경우
        const allNumeric = values.every(isNumeric);
        const encodedKey = encodeURIComponent(key);

        if (allNumeric) {
            if (values.length === 1) {
                return `${encodedKey}=eq.${values[0]}`;
            } else {
                return `${encodedKey}=in.(${values.join(",")})`;
            }
        } else {
            if (values.length === 1) {
                return `${encodedKey}_as_text=like(any).{*${encodeURIComponent(values[0])}*}`;
            } else {
                const orParts = values.map(v => `${encodedKey}_as_text.like(any).{*${encodeURIComponent(v)}*}`);
                return `or=(${orParts.join(",")})`;
            }
        }
    };
    const generatePostgrestURL = () => {
        const queryParts = [];

        for (const [key, values] of Object.entries(selected)) {
            if (values.length > 0) {
                queryParts.push(encodeParam(key, values));
            }
        }

        const queryString = queryParts.length > 0 ? "?" + queryParts.join("&") : "";
        setSearchQuery(queryString);

        return `${queryString}`;
    };

    return (<section>
        <div>{
            checkboxData && Object.entries(checkboxData).map(([group, items]) =>
                !hiddenFilter.has(group) &&
                <div key={group} className="border p-4 mb-4 rounded-lg shadow-sm inline-block mr-4">
                    <div className={`flex items-center mb-2 gap-4`}>
                        <h2 className="font-bold text-lg ">{group}</h2>
                        <button
                            onClick={() => {
                                addFilter(group)
                            }}
                            className={`py-2 px-4 bg-slate-800 text-white text-sm rounded-full`}>숨기기
                        </button>
                    </div>
                    <div className="flex flex-wrap gap-3 ">
                        {Array.from(items).map((item) =>
                            <label key={`FSKey${item}`} className="flex items-center gap-3">
                                <input
                                    className='!m-0'
                                    type="checkbox"
                                    checked={selected[group]?.includes(item) || false}
                                    onChange={() => handleChange(group, item)}
                                />
                                <span className="text-sm">{item}</span>
                            </label>
                        )}
                    </div>
                </div>
            )}
            <h1 className={`text-3xl font-extrabold mt-6`}>{[...hiddenFilter].length > 0 ? "숨겨진 필터" : ""}</h1>
            <div className={`flex flex-wrap gap-4`}>{
                [...hiddenFilter].map((e, i) =>
                    <button onClick={() => removeFilter(e)}
                            className={` py-2 px-3 bg-slate-800 text-white font-bold text-xl rounded-xl`}
                            key={i}>{e} <span className={`text-yellow-400 ml-2`}> X</span></button>)
            }</div>
        </div>
        <div className={styles.actionButtons}>
            <button className={`bg-black px-4 py-2  text-white flex gap-2`}
                    onClick={download}>
                <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/32a42da201634d63a2618e6479073a97b30ffc9873e39a522dc1562601945534?placeholderIfAbsent=true&apiKey=57ce1e6c5ff44d3ea8eda8a1d09f483d"
                    alt="" className={styles.buttonIcon}
                />
                엑셀 다운로드
            </button>
            {pathname === Const.TEST.url || pathname === Const.USER.url ?
                <button className={`bg-black px-4 py-2  text-white flex gap-2`}
                        onClick={() => nav(pathname + '/create')}>
                    + 추가
                </button> : null}
            {pathname === Const.TEST.url ?
                <button className={`bg-black px-4 py-2  text-white flex gap-2`}
                        onClick={() => nav(pathname + '/add')}>
                    + 회차 추가
                </button> : null}
            <button className={`bg-black px-4 py-2  text-white flex gap-2`}
                    onClick={() => {
                        setSelected(getInitialSelected(checkboxData)); // 필터 초기화
                        setSearchQuery("")
                    }}>
                <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/024bf6db325fa06769c3f0d11036f930c195b3749898408ff5c1920d31c0525e?placeholderIfAbsent=true&apiKey=57ce1e6c5ff44d3ea8eda8a1d09f483d"
                    alt="" className={styles.buttonIcon}/>
                초기화
            </button>
            <button className={`bg-black px-4 py-2  text-white flex gap-2`}
                    onClick={() => search()}>
                <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/82d52154b121ec9d0f349eeee64a6b10c0a5e21d33ae2217883ad30b388af7b2?placeholderIfAbsent=true&apiKey=57ce1e6c5ff44d3ea8eda8a1d09f483d"
                    alt="" className={styles.buttonIcon}/>검색
            </button>
        </div>
    </section>)
}

// 사이트 구분 | 메타번역 시험 문서
// 가입 경로 | 본인인증 카카오 네이버 구글
//  알림 설정 | 문자 카카오톡 이메일
// 마케팅 설정 | 문자 카카오톡 이메일
// 지역 | 서울 경기도 부산 대구 강원 충청도 전라도 경상도 그 외 미국 유럽 중국 그 외 해외
// 접수 구분 | 정시 차시
//
//
//
//
///